module.exports = "/build/web/svg/sponsor/heineken.6b93c368c080a7e7f9909ebb09fd2f42.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/heineken.svg
// module id = 213
// module chunks = 24